import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const STATUS = {
  nuevo: "bg-[#F4A261]/20 text-[#9a5a1f]",
  contactado: "bg-sky-100 text-sky-800",
  cliente: "bg-[#2A9D8F]/15 text-[#1f7a6f]",
};

export const fmtDate = (d) => new Date(d).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" });

const StatusSelect = ({ kind, item, field, onChange }) => {
  const update = async (status) => {
    try {
      await api.patch(`/admin/${kind}/${item.id}/status`, { status });
      onChange(item.id, field, status);
      toast.success("Estado actualizado");
    } catch {
      toast.error("No se pudo actualizar el estado");
    }
  };
  return (
    <Select value={item[field]} onValueChange={update}>
      <SelectTrigger data-testid={`status-select-${kind}-${item.id}`} className={`h-8 w-[130px] border-0 text-xs font-semibold ${STATUS[item[field]]}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        {Object.keys(STATUS).map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};

export const DataTable = ({ kind, rows, columns, statusField = "status", onChange }) => (
  <div className="overflow-x-auto rounded-2xl border border-[#E8E1D7] bg-white">
    <Table data-testid={`admin-${kind}-table`}>
      <TableHeader>
        <TableRow>
          {columns.map((c) => <TableHead key={c.key} className="whitespace-nowrap">{c.label}</TableHead>)}
          <TableHead>Estado</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && (
          <TableRow><TableCell colSpan={columns.length + 1} className="py-12 text-center text-[#6E655F]">Todavía no hay registros.</TableCell></TableRow>
        )}
        {rows.map((r) => (
          <TableRow key={r.id} data-testid={`admin-${kind}-row`}>
            {columns.map((c) => <TableCell key={c.key} className="max-w-[260px] align-top text-sm">{c.render ? c.render(r) : r[c.key] || "—"}</TableCell>)}
            <TableCell><StatusSelect kind={kind} item={r} field={statusField} onChange={onChange} /></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
